import { useMemo } from "react";

import { TransactionStatus, FinancialActivity } from "../../../api/services";
import { formatMoneyWithSign } from "../../../utils/formatMoney";
import { useRouteMatch } from "react-router-dom";

export const FINANCIAL_ACTIVITY_TITLE_TEXT: { [key: string]: string } = {
  Payment: "Payment",
  DunningCharge: "Dunning Charge",
  Deposit: "Deposit Owned",
  Repayment: "Refund",
  WriteOff: "Debit Write Off",
  WriteOn: "Debit Write On",
  CreditWriteOff: "Credit Write Off",
  AccountCredit: "Credit",
  AccountDebit: "Debit",
  OutgoingBalanceTransfer: "Balance Transfer",
  IncomingBalanceTransfer: "Balance Transfer",
  PaygTransfer: "PayG Transfer",
};

const ACTIVITIES_WITH_CREDIT = [
  "OutgoingBalanceTransfer",
  "IncomingBalanceTransfer",
  "PaygTransfer",
];

const getTitle = (
  type: string,
  currency: string,
  amount: string,
  isCredit: boolean,
  isCancellation: boolean,
  status: TransactionStatus,
) => {
  const activityType = FINANCIAL_ACTIVITY_TITLE_TEXT[type];
  const prefix = isCancellation
    ? "Reversed "
    : status === "Rejected"
    ? "Rejected "
    : "";
  const title = `${prefix}${activityType}: ${formatMoneyWithSign(
    currency,
    amount,
  )}`;

  const suffix = ACTIVITIES_WITH_CREDIT.includes(type)
    ? isCredit
      ? "CR"
      : "DR"
    : null;

  return {
    title,
    suffix,
  };
};

export const useFinancialActivity = (activity: FinancialActivity) => {
  const {
    type,
    currency,
    amount,
    isCredit,
    isCancellation,
    transactionStatus,
    financialEntityId,
  } = activity;
  const { url } = useRouteMatch();

  return useMemo(
    () => ({
      ...getTitle(
        type,
        currency,
        amount,
        isCredit,
        isCancellation,
        transactionStatus,
      ),
      link:
        financialEntityId != null && type === "Payment"
          ? `${url.replace(/\/$/, "")}/payments/${encodeURIComponent(
              financialEntityId,
            )}`
          : undefined,
      isPending:
        transactionStatus === "Pending" || transactionStatus === "Authorising",
    }),
    [
      type,
      currency,
      amount,
      isCredit,
      isCancellation,
      transactionStatus,
      financialEntityId,
      url,
    ],
  );
};
